import { createStyles, Title } from '@mantine/core'
import { get } from 'lodash'
import React, { ReactElement } from 'react'

import { TAddressSearchItem } from '../../features/AddressSearch/types'
import { Map, TMapProps } from '../../features/Map'
import { PinLayer } from './PinLayer'

type LocationMapProps = {
  value?: [number | string, number | string] | null
  onChange?: (value: [number, number] | null) => void
  popover?: React.ReactElement
  showCoordinates?: boolean
  allowChange?: boolean
} & TMapProps

const useStyle = createStyles((theme) => ({
  root: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    height: '85vh',
    overflowY: 'hidden',
  },
}))

export const LocationMap = (props: LocationMapProps): ReactElement => {
  const { value, onChange, popover, showCoordinates, allowChange, ...rest } =
    props

  const { classes } = useStyle()

  const onAddressSelected = (address: TAddressSearchItem): void => {
    if (!onChange) return
    onChange(address.lonlat ? (address.lonlat as [number, number]) : null)
  }

  const onLocationChanged = ({
    coords,
  }: {
    coords: { lat: number; lng: number }
  }): void => {
    if (!onChange) return
    onChange([coords.lat, coords.lng])
  }

  return (
    <>
      <div className={classes.root}>
        <Map showAddressSearch onAddressSelected={onAddressSelected} {...rest}>
          <PinLayer
            location={
              get(value, 0)
                ? {
                    lat: get(value, 1) as number,
                    lng: get(value, 0) as number,
                  }
                : null
            }
            onChange={allowChange ? onLocationChanged : undefined}
            popover={popover}
          />
        </Map>

        {showCoordinates && (
          <Title order={6} align="center" className="mt-2">
            {value
              ? `${i18n.t('coordinates', 'Koordinaten')}: ${Number(
                  value[0],
                ).toFixed(6)}, ${Number(value[1]).toFixed(6)}`
              : 'Keine Adresse'}
          </Title>
        )}
      </div>
    </>
  )
}
